import { useRef, useState } from "react";
import { CatSelectList } from "../../cat/CatSelectList";
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ButtonMenu } from "../../common/ButtonMenu";
import { useTranslation } from "react-i18next";

export function QueCat({courseId,question,objCats,onChange})
{
    const {t}=useTranslation();    
    const [catType,setCatType] = useState('OUTCOME');

    const op = useRef(null);
    const deleteCat=(data)=>{
        var newCats=[...objCats];
        var ind = newCats.findIndex((item)=>item.id==data.id);
        newCats.splice(ind,1);
        setCats(newCats);
    };
    const deleteBtn=(data) => <i className="pi pi-times p-button p-button-sm p-button-rounded p-button-danger p-button-text" 
        onClick={()=>deleteCat(data)}/>;
    const onCatSelect=(cat)=>{
        var newCats=[...objCats];
        var ind = newCats.findIndex((item)=>item.id==cat.id);
        if(ind<0)
        {
            newCats.push(cat);
            setCats(newCats);    
        }
        op.current.hide();
    }
    const setCats=(cats)=>{
        onChange(cats);
    };
    const popupSelector=(e,ct)=>{
        op.current.toggle(e);
    };
    const itemTemplate=(item)=>{
        return(
            <div className="flex flex-row gap-1">
                <span style={{width:'120px'}}>{item.code}</span>
                <span>{item.name}</span>
                {deleteBtn(item)}
            </div>
        )
    }
    return(
        <>        
            <div className="flex flex-column gap-4 m-2" style={{height:'200px',overflow:'auto'}}>
                <div className="flex">
                    <Button size="small" label={t('Add')} icon="pi pi-plus" onClick={(e) => popupSelector(e,'OUTCOME')} style={{width:'80px'}}></Button>
                    <OverlayPanel ref={op}>
                        <CatSelectList parentId={courseId} catType={catType} onSelect={onCatSelect}/>
                    </OverlayPanel>
                </div>
                <div className="flex-grow-1">
                    <DataTable size="small" showGridlines stripedRows value={objCats} style={{minHeight:'10rem'}}> 
                        <Column field="code" header={t('Code')} style={{width:'15%'}}></Column>
                        <Column field="name" header={t('Name')} style={{width:'80%'}}></Column>
                        <Column style={{width:'5%'}} body={deleteBtn}></Column>
                    </DataTable>
                </div>
            </div>
        </>
    );
}